import React from "react";
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Building2 } from "lucide-react";
import { UseFormReturn } from "react-hook-form";
import { User } from "@/hooks/useUsers";
import { useCompanies } from "@/hooks/useCompanies";

interface UserCompanyFieldProps {
  form: UseFormReturn<Omit<User, "id">>;
}

export const UserCompanyField = ({ form }: UserCompanyFieldProps) => {
  const { companies, isLoading } = useCompanies();

  if (isLoading) {
    return null;
  }

  return (
    <FormField
      control={form.control}
      name="companyId"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Empresa (opcional)</FormLabel>
          <Select onValueChange={field.onChange} value={field.value}>
            <FormControl>
              <div className="relative">
                <Building2 className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
                <SelectTrigger className="pl-8">
                  <SelectValue placeholder="Selecione a empresa" />
                </SelectTrigger>
              </div>
            </FormControl>
            <SelectContent>
              {companies.map((company) => (
                <SelectItem key={company.id} value={company.id}>
                  {company.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};